import { createSelector } from '@reduxjs/toolkit';
import { selectRegionalDistrictsModal } from './selectRegionalDistrictsModal';

export const selectRegionalDistrictsForList = createSelector(selectRegionalDistrictsModal, ({ districts }) =>
  districts.map(({ id, name }) => ({ value: id, label: name })),
);
